import { FC, useCallback } from 'react';
import type { Quiz } from '@teachur/http-client';
import { AnswerOption } from './AnswerOptions';
import type { UserAnswers } from './ExamQuestionModal';

interface ExamQuestionBodyProps {
  quiz: Quiz;
  currentQuestionIndex: number;
  userAnswers: UserAnswers;
  setUserAnswers: (userAnswers: UserAnswers) => void;
  setCurrentQuestionIndex: (currentQuestionIndex: number) => void;
}

export const ExamQuestionBody: FC<ExamQuestionBodyProps> = ({
  quiz,
  currentQuestionIndex,
  userAnswers,
  setUserAnswers,
}) => {
  const currentAssessment = quiz.assessments?.[currentQuestionIndex];

  if (!currentAssessment || !currentAssessment.answers) return null;

  const selectedAnswerId = userAnswers[currentAssessment.id];

  const onAnswerSelect = useCallback(
    (assessmentId: number, answerId: number) => {
      setUserAnswers({ ...userAnswers, [assessmentId]: answerId });
    },
    [quiz.assessments, userAnswers, currentQuestionIndex]
  );

  return (
    <div className="flex-1 overflow-y-auto h-full min-h-0">
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-1 ">
          <p className="text-(--neutral-black-NB500) [font-size:var(--fs-p4)] lg:[font-size:var(--fs-p3)] font-medium m-0!">
            Question:
          </p>
          <h3 className="[font-size:var(--fs-p3)] lg:[font-size:var(--fs-p1)] text-(--neutral-black-NB1000)! font-semibold leading-[150%] [font-family:var(--font-montserrat)]! m-0!">
            {currentAssessment.question}
          </h3>
        </div>

        <div className="flex flex-col gap-5">
          {currentAssessment.answers.map((answer) => (
            <AnswerOption
              key={answer.id}
              answer={answer}
              isSelected={selectedAnswerId === answer.id}
              onSelect={() => onAnswerSelect(currentAssessment.id, answer.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
